import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MESSAGE_CATEGORY_CONSTATNS } from '../constants/constant';

@Injectable({
  providedIn: 'root'
})
export class CommonToastService {

  constructor(private toastr: ToastrService) { }

  showSuccess(title: string, message: string) {
    this.toastr.success(message, title, {});
  }

  showWarning(title: string, message: string) {
    this.toastr.warning(message, title, {});
  }

  showInfo(title: string, message: string) {
    this.toastr.info(message, title, {});
  }

  showError(title: string, message: string): void {
    this.toastr.error(message, title, {});
  }
  showToasterMessage(key: string, title_: string, message_: string): void {
    const checkAlreadyExistToast = this.toastr.findDuplicate(title_, message_,false,false);
    if(checkAlreadyExistToast === null  || checkAlreadyExistToast === undefined) {
      let title = "";
      let message = "";
       if(title_) {
        title = title_.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
       }
       if(message_) {
        message = message_.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
       }
      if(key === MESSAGE_CATEGORY_CONSTATNS.ERROR) {
        this.showError(title,message);
       }else if(key === MESSAGE_CATEGORY_CONSTATNS.INFO) {
         this.showInfo(title,message);
       }else if(key === MESSAGE_CATEGORY_CONSTATNS.WARNING) {
         this.showWarning(title,message);
       }else if(key === MESSAGE_CATEGORY_CONSTATNS.SUCCESS) {
         this.showSuccess(title,message);
       }
    }
  }
}
